var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.33325L9.04905 8.45159C8.37906 8.73825 7.62094 8.73825 6.95095 8.45159L2 6.33325M4.66667 13.3333H11.3333C12.8061 13.3333 14 12.1393 14 10.6666V5.99992C14 4.52716 12.8061 3.33325 11.3333 3.33325H4.66667C3.19391 3.33325 2 4.52716 2 5.99992V10.6666C2 12.1393 3.19391 13.3333 4.66667 13.3333Z",
    stroke: "#868C89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgEmail;